import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextInput,
  Button,
  Container,
  Grid,
  Loader,
  Notification,
} from "@mantine/core";
import { IconCheck, IconCross, IconX } from "@tabler/icons";
import { NotificationStyles } from "./Dashboard";
import LoginService from "../services/LoginService";
import StorageService from "../services/StorageService";
import profile from "../assets/profile.png";
import { LoginPayload } from "../model/Login";
import "../style/index.css";
import { authCheck } from "../App";
const storageService = new StorageService();
const loginService = new LoginService();

function Login() {
  const [phoneNo, setPhoneNo] = React.useState<string>("");
  const [countryCode, setCountryCode] = React.useState<string>("91");
  const [otp, setOtp] = React.useState<string>("");
  const [showOtp, setShowOtp] = React.useState<boolean>(false);

  const [loading, setLoading] = React.useState<boolean>(false);

  const [errorFlag, setErrorFlag] = React.useState<boolean>(false);
  const [errorFlagPhone, setErrorFlagPhone] = React.useState<boolean>(false);
  const [error, setError] = React.useState<boolean>(false);

  let navigate = useNavigate();

  useEffect(() => {
    authCheck().then((e) => {
      if (e) {
        navigate("/");
      }
    });
  }, []);
  function startLogin() {
    setError(false);
    let onResponse = (data: any) => {
      setShowOtp(true);
      setLoading(false);
    };
    let onError = (error: any) => {
      setError(true);
      setLoading(false);
    };

    if (phoneNo && phoneNo.length !== 10) {
      setErrorFlagPhone(true);
      setLoading(false);
    } else {
      setErrorFlagPhone(false);
      loginService.getOtp(phoneNo, countryCode, onResponse, onError);
    }
  }

  const validateOtp = () => {
    let requestBody: LoginPayload = {
      countryCode: parseInt(countryCode),
      phoneNo: parseInt(phoneNo),
      otp: parseInt(otp),
    };

    let onResponse = (data: any) => {
      console.log("datata", data);
      if (data && data.accessToken !== undefined && data.accessToken !== "") {
        storageService.set("token", data.accessToken);
        storageService.set("phone_no", phoneNo);
        storageService.set("countryCode", countryCode);
        setTimeout(() => {
          // navigate("/");
          setLoading(false);
          window.location.href = "/";
        }, 2000);
      } else {
        setErrorFlag(true);
        setLoading(false);
        setTimeout(() => {
          setErrorFlag(false);
        }, 4000);
      }
    };
    let onError = (error: any) => {
      setLoading(false);
    };
    loginService.validateOtp(requestBody, onResponse, onError);
  };
  return (
    <Container className="main-container">
      <Grid className="center-div">
        <Grid.Col span={10} style={{ textAlign: "center" }}>
          <img className="login-page-img" src={profile}></img>
        </Grid.Col>
      </Grid>
      <Grid className="center-div">
        <Grid.Col span={10}>
          <TextInput
            icon={<div>{countryCode}</div>}
            label="Phone No"
            value={phoneNo}
            type="tel"
            onChange={(event) => {
              let input = event.target.value;
              input = input.replace(/\D/g, "");
              if (input.length <= 10) {
                setPhoneNo(input);
              }
            }}
            error={errorFlagPhone ? "Check mobile number" : ""}
          />
        </Grid.Col>
      </Grid>
      {showOtp && (
        <Grid className="center-div">
          <Grid.Col span={10}>
            <TextInput
              label="Otp"
              type="tel"
              value={otp}
              onChange={(event) => {
                let input = event.target.value;
                input = input.replace(/\D/g, "");

                if (input.length <= 5) {
                  setOtp(input);
                }
              }}
              error={errorFlag ? "Invalid Otp" : ""}
            />
          </Grid.Col>
        </Grid>
      )}
      {loading && (
        <Grid className="center-div">
          <Grid.Col
            span={8}
            style={{
              textAlignLast: "center",
            }}
          >
            <Loader />
          </Grid.Col>
        </Grid>
      )}

      <Grid className="center-div">
        <Grid.Col
          span={8}
          style={{
            textAlignLast: "center",
          }}
        >
          <Button
            className="btn-color"
            onClick={() => {
              setLoading(true);
              showOtp ? validateOtp() : startLogin();
            }}
          >
            {showOtp ? "Login" : "Proceed"}
          </Button>{" "}
        </Grid.Col>
      </Grid>
      {error && (
        <div style={NotificationStyles}>
          <Notification
            icon={<IconX size={18} />}
            color="red"
            title="Phone number not whitelisted."
            onClose={() => setError(false)}
          ></Notification>
        </div>
      )}
    </Container>
  );
}
export default Login;
